import { takeEvery } from 'redux-saga/effects';
import {
    fetchCompanies,
    fetchAllContainers,
    fetchInheritedCompanies,
    fetchLevels,
    fetchSites,
    fetchInheritedSites,
    fetchContainersByLevels,
} from '../slice';
import { getCompanies, getInheritedCompanies } from './companiesSaga';
import { getAllContainers, getContainersByLevels } from './containersSaga';
import { getLevels } from './levelsSaga';
import { getSites, getInheritedSites } from './sitesSaga';

const resourcesAssignmentSagas = [
    takeEvery(fetchCompanies.type, getCompanies),
    takeEvery(fetchInheritedCompanies.type, getInheritedCompanies),
    takeEvery(fetchAllContainers.type, getAllContainers),
    takeEvery(fetchContainersByLevels.type, getContainersByLevels),
    takeEvery(fetchLevels.type, getLevels),
    takeEvery(fetchSites.type, getSites),
    takeEvery(fetchInheritedSites.type, getInheritedSites),
];

export default resourcesAssignmentSagas;
